export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/twitter.11d56299.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};